import Check from '@mui/icons-material/Check'
import MoreHoriz from '@mui/icons-material/MoreHoriz'
import { Fade, Menu, MenuItem } from '@mui/material'
import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { buildNotificationData } from '../logic/handle-notifications'
import {
  NotificationContextMenuActionButton,
  NotificationListItemContainer,
  NotificationListItemPrimary,
  NotificationListItemSecondary,
  NotificationListItemTime,
  NotificationMenuItemContainer,
} from './styledComponents'

export default function NotificationListItemComponent({
  notificationData,
  index,
  handleMarkRead,
  closeNotificationList,
}) {
  const [notificationContextMenuAnchor, setNotificationContextMenuAnchor] = useState(null)
  const [showContextMenu, setShowContextMenu] = useState(false)
  const navigate = useNavigate()
  const notificationLogic = useMemo(() => {
    return buildNotificationData(notificationData, { navigate })
  }, [notificationData, navigate])

  function handleNotificationClick() {
    closeNotificationList()
    notificationLogic?.onClick()
    handleMarkRead(notificationData?.notificationId)
  }

  function handleNotificationContextMenuClick(event) {
    setNotificationContextMenuAnchor(event.currentTarget)
    setShowContextMenu(true)
  }
  function handleNotificationContextMenuClose() {
    setShowContextMenu(false)
  }

  function onExitedContextMenu() {
    setNotificationContextMenuAnchor(null)
    setShowContextMenu(false)
  }

  async function markNotificationAsRead() {
    // console.log({ notificationDataId: notificationData?.id, notificationData })
    handleNotificationContextMenuClose()
    handleMarkRead(notificationData?.notificationId)
    // const resp = await putDataWithParams(
    //   '/api/secure/user/notification/update-read',
    //   {},
    //   {
    //     notificationId: notificationData?.notificationId,
    //   },
    // )

    // if (resp.status === 200 && isCommonResponseSuccessful(resp?.data?.code)) {
    //   refreshNotifications()
    // } else {
    //   toast.error('Could not mark notification as read. Please try again.')
    // }
  }

  return (
    <NotificationMenuItemContainer>
      <MenuItem
        onClick={(event) => handleNotificationClick(event, index)}
        // sx={{ position: 'relative' }}
        disableTouchRipple
      >
        <NotificationListItemContainer read={notificationData?.read}>
          {notificationData?.title && (
            <NotificationListItemPrimary>{notificationData?.title}</NotificationListItemPrimary>
          )}
          {notificationData?.description && (
            <NotificationListItemSecondary>
              {notificationData?.description && notificationData?.description.length > 100
                ? notificationData?.description.slice(0, 100) + '...'
                : notificationData?.description}
            </NotificationListItemSecondary>
          )}
          {notificationData?.createdTime && (
            <NotificationListItemTime read={notificationData?.read}>
              {dayjs.utc(notificationData?.createdTime).local().fromNow()}
            </NotificationListItemTime>
          )}
        </NotificationListItemContainer>
      </MenuItem>
      {!notificationData?.read && (
        <NotificationContextMenuActionButton
          size="small"
          showButton={Boolean(notificationContextMenuAnchor)}
          onClick={handleNotificationContextMenuClick}
        >
          <MoreHoriz />
        </NotificationContextMenuActionButton>
      )}
      <Menu
        anchorEl={notificationContextMenuAnchor}
        open={showContextMenu}
        onClose={handleNotificationContextMenuClose}
        TransitionProps={{ onExited: onExitedContextMenu, timeout: 100 }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        TransitionComponent={Fade}
        sx={{ padding: '0px 10px !important', marginTop: '2px' }}
      >
        <MenuItem onClick={markNotificationAsRead} disableTouchRipple>
          <NotificationListItemContainer style={{ padding: '0px' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
                alignItems: 'center',
                fontWeight: 600,
              }}
            >
              <Check sx={{ fontSize: '15px' }} />
              <NotificationListItemSecondary>Mark as read</NotificationListItemSecondary>
            </div>
          </NotificationListItemContainer>
        </MenuItem>
      </Menu>
    </NotificationMenuItemContainer>
  )
}
